/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_P1Inputs */

const tr_iade_iptal_s11_p1 = /** @type {(inputs: Iade_Iptal_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik sona erdiğinde aşağıdaki kurallar uygulanır:`)
};

const en_iade_iptal_s11_p1 = /** @type {(inputs: Iade_Iptal_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following rules apply when the subscription ends:`)
};

const de_iade_iptal_s11_p1 = /** @type {(inputs: Iade_Iptal_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach dem Ende des Abonnements gelten folgende Regeln:`)
};

const ru_iade_iptal_s11_p1 = /** @type {(inputs: Iade_Iptal_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После окончания подписки действуют следующие правила:`)
};

/**
* | output |
* | --- |
* | "The following rules apply when the subscription ends:" |
*
* @param {Iade_Iptal_S11_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_p1 = /** @type {((inputs?: Iade_Iptal_S11_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_p1(inputs)
	if (locale === "de") return de_iade_iptal_s11_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_p1(inputs)
	return tr_iade_iptal_s11_p1(inputs)
});